/* CAFFREY Revive Leather Conditioner Lotion: page behaviour v6 (launch build · Claude Code, launch agent, 2026-10-07).
   Two small jobs; everything else on the page is native HTML, Dawn's product form and the CAFFREY kit (cf-kit.js).
   1. Speed: the pictures just below the first screen wait in <noscript data-rlc-defer>, and the display serif (Libre
      Bodoni 500 + italic, [data-rlc-fonts]) waits too, until the hero photo has loaded (4 s at the latest), so on a slow
      phone they don't share the line with the page's largest paint. The picture boxes are reserved by aspect-ratio and
      the H1's line boxes are fixed, so nothing moves when they arrive; the pictures stay loading="lazy".
      A shopper who scrolls, taps or presses a key before that gets them at once (fix 2026-10-07: on a slow phone an
      early scroll could meet an empty picture box for 1-3 s).
      Without JavaScript the browser shows the pictures and loads the fonts from the noscript @font-face rules.
   2. A routine card for a product sold in sizes (here Cedar Shoe Trees) starts with no size chosen (LAUNCH-BRIEF
      bulletin 6: wrong size is the category's top return reason). The kit card pre-selects the first size, so this adds
      a "Choose your size" first option and holds that card's Add to cart, with a short message, until a size is picked.
      Without JavaScript the kit card works as before.
   Replaces cf-rlc-v5.js on this template. */
(() => {
  if (window.CaffreyRevLotion6) { window.CaffreyRevLotion6.run(); return; }

  const strings = () => {
    const el = document.querySelector('[data-rlc-strings]');
    try { return JSON.parse(el ? el.textContent : '{}') || {}; } catch (e) { return {}; }
  };
  const SELECT = '.cf-kit-routine form select[name="id"]';

  const prepare = () => {
    const s = strings();
    document.querySelectorAll(SELECT).forEach(select => {
      if (select.dataset.rlcPrompt) return;
      select.dataset.rlcPrompt = 'true';
      const first = document.createElement('option');
      first.value = '';
      first.disabled = true;
      first.textContent = s.choose || 'Choose your size';
      select.insertBefore(first, select.firstChild);
      first.selected = true;
      first.defaultSelected = true;
    });
  };

  const box = el => {
    const pf = el.closest('product-form');
    const wrap = pf ? pf.querySelector('.product-form__error-message-wrapper') : null;
    return { wrap, msg: wrap ? wrap.querySelector('.product-form__error-message') : null };
  };

  // Capture phase: runs before Dawn's product-form submit handler on the form itself.
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.closest('.cf-kit-routine')) return;
    const select = form.querySelector('select[name="id"]');
    if (!select || select.value) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const { wrap, msg } = box(form);
    if (wrap && msg) {
      msg.textContent = strings().note || 'Choose a size first.';
      wrap.hidden = false;
    }
    select.focus();
  }, true);

  document.addEventListener('change', event => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement) || !select.matches(SELECT) || !select.value) return;
    const { wrap } = box(select);
    if (wrap) wrap.hidden = true;
  });

  let fontsAdded = false;
  const loadFonts = () => {
    const el = document.querySelector('[data-rlc-fonts]');
    if (fontsAdded || !el || !document.fonts || typeof FontFace === 'undefined') return;
    fontsAdded = true;
    let cfg = {};
    try { cfg = JSON.parse(el.textContent) || {}; } catch (e) { return; }
    // Shopify's font.family arrives CSS-quoted ("Libre Bodoni"); FontFace takes the bare family name.
    const family = String(cfg.family || '').trim().replace(/^["']+|["']+$/g, '');
    (cfg.faces || []).forEach(f => {
      if (!f || !f.url || !family) return;
      const face = new FontFace(family, `url("${f.url}") format("woff2")`, { weight: String(f.weight || 400), style: f.style || 'normal', display: 'swap' });
      document.fonts.add(face);
      face.load().catch(() => {});
    });
  };

  let released = false;
  const release = () => {
    loadFonts();
    if (released) return;
    released = true;
    document.querySelectorAll('noscript[data-rlc-defer]').forEach(ns => {
      const html = ns.textContent;
      if (html && html.indexOf('<img') !== -1) ns.insertAdjacentHTML('beforebegin', html);
      ns.remove();
    });
  };
  const holdUntilHero = () => {
    const hero = document.querySelector('.rlc-hero__img');
    if (!hero || (hero.complete && hero.naturalWidth > 0)) { release(); return; }
    hero.addEventListener('load', release, { once: true });
    hero.addEventListener('error', release, { once: true });
    ['scroll', 'touchstart', 'pointerdown', 'wheel', 'keydown'].forEach(type =>
      window.addEventListener(type, release, { once: true, passive: true, capture: true }));
    setTimeout(release, 4000);
  };

  const run = () => { prepare(); holdUntilHero(); };
  document.addEventListener('shopify:section:load', () => { released = false; run(); });
  window.CaffreyRevLotion6 = { run };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
})();
